import React from 'react';
import { Typography, Image, Row, Col } from 'antd';
import { IPhoto } from '../../../../types/files';
import { questionCardStyles } from '../../styles/questionCard';

const { Text } = Typography;

interface PhotosDisplayProps {
  photos: IPhoto[];
  comment?: string;
}

const PhotosDisplay: React.FC<PhotosDisplayProps> = ({ photos, comment }) => {
  return (
    <div style={questionCardStyles.photosContainer}>
      <Row gutter={[8, 8]} style={{ marginBottom: comment ? 8 : 0 }}>
        {photos.map((photo, index) => (
          <Col span={12} key={index}>
            <Image
              src={photo.compressed || photo.original}
              alt={`Photo ${index + 1}`}
              style={questionCardStyles.photoImageSquare}
              preview={{
                src: photo.original,
              }}
            />
          </Col>
        ))}
      </Row>

      {comment && <Text style={questionCardStyles.photoComment}>{comment}</Text>}
    </div>
  );
};

export default PhotosDisplay;
